import { XCircleIcon } from "@heroicons/react/outline";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { createDiscussionSliceActions } from "../../redux/features/Modal/createDiscussionSlice";
import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";
import { auth, database } from "../../database/firebase";
import { RadioGroup } from "@headlessui/react";
import { useAuthState } from "react-firebase-hooks/auth";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import ClipLoader from "react-spinners/ClipLoader";

const people = [
  { name: "JavaScript" },
  { name: "Python" },
  { name: "Java" },
  { name: "C++" },
  { name: "Kotlin" },
  { name: "Dart" },
];

const plans = [
  {
    name: "Public",
  },
  {
    name: "Private",
  },
  {
    name: "Protected",
  },
];

const CreateDiscussionForm = () => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState(people[0]);
  const [selectedTab, setSelectedTab] = useState(plans[0]);
  const [roomName, setRoomName] = useState("");
  const [user] = useAuthState(auth);
  const [loading, setLoading] = useState(false);

  function closeModal() {
    dispatch(createDiscussionSliceActions.disableModal());
  }

  const createRoom = async () => {
    if (!selected || !selectedTab || !roomName)
      return alert("Please Enter the roomname..?");
    try {
      setLoading(true);
      await addDoc(collection(database, "userRooms"), {
        createdUser: user.displayName,
        createdUserId: user?.uid,
        createdUserEmail: user?.email,
        createUserImage: user?.photoURL,
        roomName,
        privacyMode: selectedTab.name,
        language: selected.name,
        timestamp: serverTimestamp(),
      }).then(async (docId) => {
        await addDoc(collection(database, "userRooms", docId.id, "members"), {
          memberName: user?.displayName,
          memberId: user?.uid,
          memberEmail: user?.email,
          memberImage: user?.photoURL,
          isAdmin: true,
          timestamp: serverTimestamp(),
        });
      });
      setLoading(false);
      closeModal();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="px-3 py-2">
      <div className="flex justify-between items-center">
        <h1 className="text-lg font-semibold">Create Room</h1>
        <XCircleIcon
          onClick={closeModal}
          className="h-7 text-gray-600 cursor-pointer hover:text-black"
        />
      </div>
      <div className="mt-4">
        <input
          type="text"
          value={roomName}
          onChange={(e) => setRoomName(e.target.value)}
          placeholder="Enter Room Name"
          className="border-indigo-500 border shadow-md focus:outline-none w-full py-2 px-1 rounded-md"
        />
      </div>
      <div className="w-full mt-3">
        <h1 className="pl-3 py-3">Mode</h1>
        <RadioGroup value={selectedTab} onChange={setSelectedTab}>
          <RadioGroup.Label className="sr-only">Privacy Mode.</RadioGroup.Label>
          <div className="sm:grid sm:grid-cols-3 sm:gap-3 space-y-5 sm:space-y-0">
            {plans.map((plan, index) => (
              <RadioGroup.Option
                key={index}
                value={plan}
                className={({ active, checked }) =>
                  `${active ? "bg-gray-100" : " ring-1 border-gray-400"}
                  ${
                    checked ? "bg-sky-900 bg-opacity-75 text-black" : "bg-white"
                  }
                    relative rounded-lg shadow-md px-5 py-4 cursor-pointer flex focus:outline-none`
                }
              >
                {({ active, checked }) => (
                  <>
                    <div className="flex items-center justify-between w-full">
                      <div className="flex items-center">
                        {checked && (
                          <div className="flex-shrink-0 text-indigo-500 px-2 py-1 rounded-full">
                            <CheckIcon className="w-6 h-6" />
                          </div>
                        )}
                        <div className="text-sm">
                          <RadioGroup.Label
                            as="p"
                            className={`font-medium  ${
                              checked ? "text-indigo-500" : "text-gray-900"
                            }`}
                          >
                            {plan.name}
                          </RadioGroup.Label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      </div>
      <div className="w-full mt-3 z-50">
        <h1 className="pl-3 py-3">Select Language</h1>
        <Listbox value={selected} onChange={setSelected}>
          <div className="relative mt-1">
            <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border border-indigo-500 rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
              <span className="block truncate">{selected.name}</span>
              <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon
                  className="w-5 h-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {people.map((person, personIdx) => (
                  <Listbox.Option
                    key={personIdx}
                    className={({ active }) =>
                      `${
                        active ? "text-amber-900 bg-amber-100" : "text-gray-900"
                      }
                          cursor-default select-none relative py-2 pl-10 pr-4`
                    }
                    value={person}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`${
                            selected
                              ? "font-medium"
                              : "font-normal hover:text-indigo-500 cursor-pointer"
                          } block truncate`}
                        >
                          {person.name}
                        </span>
                        {selected ? (
                          <span
                            className={`${
                              active ? "text-amber-600" : "text-amber-600"
                            }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                          >
                            <CheckIcon className="w-5 h-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </Listbox>
      </div>
      <div className="mt-8 sm:flex sm:justify-between sm:items-center py-3 space-y-4 sm:space-y-0">
        <div className="flex items-center pl-3 space-x-3">
          <input type="checkbox" />
          <label>Agree for terms and condition</label>
        </div>
        <div>
          <button
            onClick={createRoom}
            className="bg-indigo-400 text-white font-semibold px-4 py-2 rounded-md shadow-md  tracking-wider w-full"
          >
            {loading ? (
              <ClipLoader color="white" loading={loading} size={25} />
            ) : (
              "Create Room"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateDiscussionForm;
